module.exports = __webpack_public_path__ + "img/icon-time.4f5c51af.svg";